import React, { useState } from 'react';
import classNames from 'classnames';
import { Button } from '@spothero/ui';
const GettingThere = ({ instructions, showHeading = true, }) => {
    const [showFullInstructions, setShowFullInstructions] = useState(!showHeading);
    const toggleFullInstructions = () => setShowFullInstructions(show => !show);
    const classes = classNames('SpotDetails-section', 'GettingThere', {
        'GettingThere-show-full-instructions': showFullInstructions,
    });
    const formattedInstructions = instructions.replace(/\r?\n/g, '<br>');
    return (<div className={classes} data-testid="GettingThere">
            {showHeading && <h4 className="subtitle">Getting There</h4>}
            <div className="preview-container">
                <p className="instructions" dangerouslySetInnerHTML={{ __html: formattedInstructions }}/>
                <div className="overlay"/>
            </div>
            <Button variant="tertiary" fontSize="sm" className="read-more" onClick={toggleFullInstructions}>
                Show More
            </Button>
        </div>);
};
export default GettingThere;
